import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { internalizationState, updateMoreDetailsButtonData, getAllSections } from '../../../../stores/reducers/sections';
import Input from '../Input/Input'
import Radio from '../Radio/Radio';
import Checkbox from '../Checkbox/Checkbox';

export interface IMoreDetailsButtonParams {
  id: boolean;
  label: string;
  label_en: string;
  value: string;
  linkType: string;
  blank: boolean;
}

interface Props {
  params: IMoreDetailsButtonParams;
  sectionId: number;
}

const linkTypeOptions = [
  {
    label_ru: 'Ссылка на блок',
    label_en: 'Link to block',
    value: 'self'
  },
  {
    label_ru: 'Ссылка на страницу',
    label_en: 'Link to page',
    value: 'url'
  }
]

const MoreDetailsButton: FC<Props> = ({params, sectionId}) => {
  const dispatch = useDispatch();
  const sections = useSelector(getAllSections).filter((section) => section.visible && section.page === 'HomePage');  
  const langConfig = useSelector(internalizationState);

  const handleParamUpdate = (value: string | boolean, field: string) => {
    dispatch(updateMoreDetailsButtonData({ value, field, sectionId, pid: params.id }));
  };

  const onLinkInputChange = (value: string): void => {
    handleParamUpdate(value, 'value');
  };

  const onSelfLinkIdChange = (value: string) => {
    handleParamUpdate(value, 'value');
  };

  const onLinkTypeUpdate = (type: string) => {
    handleParamUpdate(type === 'self' ? '3' : '', 'value');
    handleParamUpdate(type, 'linkType');
  };

  const onBlankChange = (isBlank: boolean) => {
    handleParamUpdate(isBlank, 'blank');
  };

  return (
    <div>
      <br />
      <p className="setting-label">
        <b>{langConfig.activeLangState === 'ru' ? params.label : params.label_en}</b>
      </p>
      <div style={{marginBottom: 8}}>
        <Radio
          value={params.linkType}
          params={linkTypeOptions}
          handleChange={(type: string) => onLinkTypeUpdate(type)}
        />
      </div>
      {
        params.linkType === 'self' ?
        (
          <>
            <div className="">
              <label htmlFor="block-selection" style={{fontSize: 14}}>
                {langConfig.activeLangState === 'ru' ? 'Название целевого блока' : 'Target block name'}
              </label>
              <select
                id="block-selection"
                className="ui-input"
                value={params.value}
                onChange={(e) => onSelfLinkIdChange((e.target as HTMLSelectElement).value)}
              >
                {
                  sections.map((section) => (
                    <option key={section.id} value={section.id}>
                      {langConfig.activeLangState === 'ru' ? section.name : section.name_en}
                    </option>
                  ))
                }
              </select>
            </div>
          </>
        )
        : (
          <>
            <Input
              label={langConfig.activeLangState === 'ru' ? 'Прямая ссылка' : 'Direct link'}
              value={params.value}
              handleChange={(value: string) => onLinkInputChange(value)}
            />
            <Checkbox
              label={langConfig.activeLangState === 'ru' ? 'Открывать в новом окне' : 'Open in a new window'}
              value={params.blank}
              handleChange={(value: boolean) => onBlankChange(value)}
            />
          </>
        )
      }
    </div>
  )
};

export default MoreDetailsButton;

